export function intFromParam(value, fallback) {
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
}

export function getStoredListState(storageKey) {
  if (typeof window === 'undefined') return {};
  const raw = window.localStorage.getItem(storageKey);
  if (!raw) return {};

  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

export function getLegacyStoredLimit(storageKey, fallback = 10) {
  if (typeof window === 'undefined') return fallback;
  return intFromParam(window.localStorage.getItem(storageKey), fallback);
}

export function persistListState({ storageKey, legacyLimitKey, limit, state }) {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(legacyLimitKey, String(limit));
  window.localStorage.setItem(storageKey, JSON.stringify(state));
}

export function clearListState(storageKey, legacyLimitKey) {
  if (typeof window === 'undefined') return;
  window.localStorage.removeItem(storageKey);
  window.localStorage.removeItem(legacyLimitKey);
}

export function updateSearchParams(searchParams, setSearchParams, patch) {
  const next = new URLSearchParams(searchParams);
  Object.entries(patch).forEach(([key, value]) => {
    if (value === '' || value === null || value === undefined) {
      next.delete(key);
    } else {
      next.set(key, String(value));
    }
  });
  setSearchParams(next);
}

export function getSortIndicator(currentSort, currentOrder, field) {
  if (currentSort !== field) return '';
  return currentOrder === 'ASC' ? ' ↑' : ' ↓';
}

export function getNextSortPatch({ currentSort, currentOrder, field, defaultAscFields = [] }) {
  if (currentSort === field) {
    return { sort: field, order: currentOrder === 'ASC' ? 'DESC' : 'ASC', page: 1 };
  }

  return {
    sort: field,
    order: defaultAscFields.includes(field) ? 'ASC' : 'DESC',
    page: 1,
  };
}
